export default __webpack_public_path__ + "static/media/arrow_flat_right.837dcacf.svg";